import cx from 'classnames'
import Link from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { SecondaryButtonLink } from 'ui'

interface SubmitHomeCardProps {
  className?: string
}

const SubmitHomeCard = ({ className }: SubmitHomeCardProps) => {
  const router = useRouter()
  const { pathname, query } = router

  const { t } = useTranslation('homes')

  return (
    <div
      className={cx(
        className,
        'relative flex grid-cols-4 justify-center rounded-[15px] bg-white py-16 text-center shadow-sm sm:flex-col'
      )}
    >
      <div className="sm:pt-16">
        <Image
          src={'/certified-badge.svg'}
          alt="institution-logo"
          width={96}
          height={96}
        />
      </div>
      <div className="flex flex-col justify-between p-8 sm:justify-center sm:p-0">
        <h2 className="text-16 font-semibold sm:mx-40 sm:text-24 sm:leading-7">
          {t('submit-home.prompt')}
        </h2>
        <div className="p-16 sm:p-24 sm:pb-48">
          <Link
            href={{
              pathname,
              query: query
                ? { ...query, submitHome: true }
                : { submitHome: true },
            }}
            shallow
          >
            <SecondaryButtonLink href="#">
              {t('submit-home.title')}
            </SecondaryButtonLink>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default SubmitHomeCard
